<template>
	<div>
		<formulario-assinatura-eletronica
			v-if="exibirModalAssinaturaEletronica && idLicitacao"
			:titulo-modal="tituloModal"
			:exibir-modal="exibirModalAssinaturaEletronica"
			:documentos="documentos"
			:id-licitacao="idLicitacao"
			@assinaturas-em-processamento="tratarEventoAssinaturasEmProcessamento"
			@assinatura-concluida="tratarEventoAssinaturaConcluida"
			@fechar-modal="fecharModalAssinaturaEletronica"
		></formulario-assinatura-eletronica>

		<formulario-assinatura-digital
			v-if="exibirModalAssinaturaDigital && idLicitacao"
      :exibir-modal="exibirModalAssinaturaDigital"
			:documento="documentos[0]"
      :id-licitacao="idLicitacao"
			@fechar-modal="fecharModalAssinaturaDigital"
			@assinatura-concluida="tratarEventoAssinaturaConcluida"
		></formulario-assinatura-digital>

    <modal
        :exibir="exibir"
        :titulo="titulo"
        :max-width="600"
        @close="fecharModal"
    >
      <template #body>
        <div class="az-form-content cp-modal-form-content pa-6" style="height: 120px">
          <div class="text-center mb-3">
            <p class="text-subtitle-1 grey--text text--darken-1 mb-0">
              Selecione o tipo de assinatura desejada:
            </p>
          </div>

          <div class="d-flex justify-center" style="gap: 16px;">
            <v-btn
                class="signature-btn text-capitalize"
                color="primary"
                depressed
                :height="40"
                @click="tratarEventoAssinarEletronicamenteDocumentoProcessoDigital"
            >
              <v-icon left size="20">mdi-pen</v-icon>
              Eletronica
            </v-btn>

            <v-btn
                id="botaoAssinaturaDigital"
                class="signature-btn text-capitalize"
                color="primary"
                depressed
                :height="40"
                @click="tratarEventoAssinarDigitalmenteDocumentoProcessoDigital"
            >
              <v-icon left size="20">mdi-certificate</v-icon>
              Digital
            </v-btn>
          </div>
        </div>
      </template>
    </modal>
	</div>
</template>

<script>

import FormularioAssinaturaEletronica
  from "@/views/credenciamento/detalhe-credenciamento/assinaturas/formulario/assinatura/eletronica/FormularioAssinaturaEletronica.vue";
import FormularioAssinaturaDigital
  from "@/views/credenciamento/detalhe-credenciamento/assinaturas/formulario/assinatura/digital/FormularioAssinaturaDigital.vue";
import Modal from "@/views/credenciamento/detalhe-credenciamento/commons/Modal.vue";
export default {
	name: 'ModalSelecaoTipoAssinatura',
	components: { FormularioAssinaturaEletronica, FormularioAssinaturaDigital, Modal },
	mixins: ['notificacao'],
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		idLicitacao: {
			type: [String, Number],
			required: false,
			default: null,
		},
		titulo: {
			type: String,
			default: '',
		},
    documentos: {
      type: Array,
      default: () => [],
    },
	},
	data() {
		return {
			exibirModalAssinaturaEletronica: false,
			tituloModal: '',
      exibirModalAssinaturaDigital: false,
		}
	},
	watch: {
    exibir() {
    }
	},
	methods: {
		async buscarAssinaturasNaoConcluidas() {
			this.$emit('buscar-assinaturas-nao-concluidas')
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		fecharModalAssinaturaDigital() {
			this.exibirModalAssinaturaDigital = false
      this.fecharModal()
		},
		fecharModalAssinaturaEletronica() {
			this.exibirModalAssinaturaEletronica = false
			this.buscarAssinaturasNaoConcluidas()
			this.resetarDocumentos()
			this.fecharModal()
		},
		resetarDocumentos() {
			this.$emit('resetar-documentos')
		},
		tratarEventoAssinarDigitalmenteDocumentoProcessoDigital() {
      this.exibirModalAssinaturaDigital = true
    },
		async tratarEventoAssinarEletronicamenteDocumentoProcessoDigital() {
      this.exibirModalAssinaturaEletronica = true
      this.tituloModal = 'Assinar Eletronicamente'
		},
		tratarEventoAssinaturaConcluida() {
			this.mostrarNotificacaoSucesso('Documento assinado com sucesso!')
			this.exibirModalAssinaturaEletronica = false
			this.exibirModalAssinaturaDigital = false
			this.resetarDocumentos()
			this.fecharModal()
		},
		tratarEventoAssinaturasEmProcessamento() {
			this.fecharModalAssinaturaEletronica()
		},
	},
}
</script>
